<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ZhuangBeiPeiJian`]" width="1em" height="1em" v-bind="$attrs"><path d="M17.369 5.19504L10.3514 1.15995C10.1409 1.0196 9.8602 1.0196 9.64967 1.15995L2.63213 5.19504C2.4216 5.33539 2.28125 5.54592 2.28125 5.79153V13.8617C2.28125 14.1073 2.4216 14.3529 2.63213 14.4582L9.64967 18.4933C9.75493 18.5635 9.89529 18.5985 10.0005 18.5985C10.1058 18.5985 10.2462 18.5635 10.3514 18.4933L17.369 14.4582C17.5795 14.3178 17.7198 14.1073 17.7198 13.8617V5.79153C17.7198 5.54592 17.5795 5.33539 17.369 5.19504ZM16.3163 13.4757L10.0005 17.1249L3.68476 13.4757V6.21258L10.0005 2.56346L16.3163 6.21258V13.4757Z"/><path d="M9.29842 5.125V9.89693L5.08789 12.318L5.78964 13.5461L10.0002 11.125L14.2107 13.5461L14.9125 12.318L10.7019 9.89693V5.125H9.29842Z"/></svg>
</template>
<script>

export default {
  name: 'IconZhuangBeiPeiJian',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
